import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: Spacings.s8,
    },
  },
  {
    name: 'color-item',
  },
);

export default useStyles;
